module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cn":{"rebook":{"saveSuccess":"改签申请成功，请等侯老师确认"}},"TW":{"rebook":{"saveSuccess":"改簽申請成功，請等侯老師確認"}},"en":{"rebook":{"saveSuccess":"Please wait for the teacher\u0027s confirmation"}}}')
  delete Component.options._Ctor
}
